module.exports = __webpack_public_path__ + "static/media/icon-jpg.21900e5d.svg";